import { render, staticRenderFns } from "./PasswordForm.vue?vue&type=template&id=37c410ef&"
import script from "./PasswordForm.vue?vue&type=script&lang=ts&"
export * from "./PasswordForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCardActions,VExpandTransition})
